/**
 * Whether a stored persona choice is still reachable with the caller's
 * persona access: its circle is listed, and a chosen persona is in it.
 */
export function isPersonaAvailable(stored, circles) {
  if (!stored?.circleId) {
    return (circles || []).some((c) => (c.personas || []).some((p) => p.id === stored?.personaId));
  }
  const circle = (circles || []).find((c) => c.id === stored?.circleId);
  if (!circle) return false;
  if (!stored.personaId) return true;
  return (circle.personas || []).some((p) => p.id === stored.personaId);
}
